import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Item } from '../Item'
import { connect } from 'react-redux'
import { getCurrentAd } from '../../../selectors'
import { groups } from 'SRC/modules/ads/equipment/data/groups'
import { divideItemsToColumns } from '../../../functions'

export const List = ({ad: {equipment}}) => {
  const { t } = useTranslation('common')

  const equipmentSorted = equipment.sort((a, b) => {
    if (a.weight !== b.weight) {
      return a.weight - b.weight
    } else {
      return a.title.localeCompare(b.title)
    }
  })
  const equipmentByGroups = []
  for (let key in groups) {
    if (groups.hasOwnProperty(key)) {
      const group = {...groups[key]}
      group.children = equipmentSorted.filter(item => item.grupa === group.code).map(item => ({
        id: item.id,
        feature: item.title,
        hint: item.hint
      }))
      equipmentByGroups.push(group)
    }
  }
  return equipmentByGroups.map(({id, title, children}) => {
    if (!children.length) {
      return null
    }
    const itemsByColumn = divideItemsToColumns(children)
    return (
      <div className='oglasi-dodatna-oprema' key={id}>
        <div className='oglasi-info-heading'>
          <p>{t(title)}</p>
        </div>
        <div className='oglasi-dodatne-oprema-content'>
          {
            itemsByColumn.map(
              ul => <ul key={ul.number}>
                {ul.items.map(li => <Item key={li.id} {...li} />)}
              </ul>
            )
          }
        </div>
      </div>
    )
  })
}

const mapStateToProps = state => ({
  ad: getCurrentAd(state)
})

List.propTypes = {
  ad: PropTypes.shape({
    equipment: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      grupa: PropTypes.string.isRequired,
      hint: PropTypes.string,
      title: PropTypes.string.isRequired
    }))
  })
}

List.defaultProps = {
  items: []
}

List.displayName = 'Equipment'

export default connect(mapStateToProps)(List)
